import { ExtraTarifa } from "src/gql/schema"

export type ExtraTarifaAgrupada = {
    tarifa_id: string
    tarifa: ExtraTarifa["tarifa"]
    total: number
    entradas: {
        fecha_inicio: string
        fecha_fin: string
        subtotales: ExtraTarifa["subtotales"]
    }[]
}

export function groupExtrasTarifasByTarifa(
    extras_tarifas: ExtraTarifa[]
): ExtraTarifaAgrupada[] {
    const map = extras_tarifas.reduce<Record<string, ExtraTarifaAgrupada>>((acc, item) => {
        if (!acc[item.tarifa_id]) {
            acc[item.tarifa_id] = {
                tarifa_id: item.tarifa_id,
                tarifa: item.tarifa,
                total: 0,
                entradas: [],
            }
        }
        acc[item.tarifa_id].entradas.push({
            fecha_inicio: item.fecha_inicio,
            fecha_fin: item.fecha_fin,
            subtotales: item.subtotales,
        })
        acc[item.tarifa_id].total += item.subtotales?.total ?? 0
        return acc
    }, {})

    return Object.values(map)
}
